export const apiConstants = {
  users: 'mock-data/users.json'
};
